import nextId from "react-id-generator"
import featured6 from "../../images/featured6.jpg"
import featured5 from "../../images/featured5.png"
import featured4 from "../../images/featured4.png"
import featured3 from "../../images/featured3.png"
import featured2 from "../../images/featured2.jpg"
import featured1 from "../../images/featured1.jpg"
import drone3 from "../../images/drone3.png"
import dronekit from "../../images/drone-kit.png"
import drone7 from "../../images/drone7.png"

export const products = [
    {
        id: nextId(),
        image: featured6,
        title: "some drone",
        price: "1500 €"
    },
    {
        id: nextId(),
        image: featured5,
        title: "some drone",
        price: "1500 €"
    },
    {
        id: nextId(),
        image: featured4,
        title: "some drone",
        price: "1500 €"
    },
    {
        id: nextId(),
        image: featured3,
        title: "some drone",
        price: "1500 €"
    },
    {
        id: nextId(),
        image: featured2,
        title: "some drone",
        price: "1500 €"
    },
    {
        id: nextId(),
        image: featured1,
        title: "some drone",
        price: "1500 €"
    },
    {
        id: nextId(),
        image: drone7,
        title: "some drone",
        price: "1500 €"
    },
    {
        id: nextId(),
        image: drone3,
        title: "some drone",
        price: "1500 €"
    },
    {
        id: nextId(),
        image: dronekit,
        title: "some drone",
        price: "1500 €"
    },
];